import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const preventZoom = event => {
  if (event.ctrlKey || event.metaKey) {
    event.preventDefault();
  }
};

const preventKeyboardZoom = event => {
  if (
    (event.ctrlKey || event.metaKey) &&
    ['+', '-', '=', '0'].includes(event.key)
  ) {
    event.preventDefault();
  }
};

document.addEventListener('wheel', preventZoom, { passive: false });
document.addEventListener('keydown', preventKeyboardZoom);
document.addEventListener('gesturestart', event => event.preventDefault());
document.addEventListener('gesturechange', event => event.preventDefault());
document.addEventListener('gestureend', event => event.preventDefault());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
